import apiHandler from '../core/apiHandler';

/**
 * API para consultar el estado efectivo de las funcionalidades del sistema
 * según el plan activo.
 *
 * GET /api/system/features  ->  { data: { SALES: true, RESTAURANT: false, ... } }
 */
const systemFeatureApi = apiHandler('system/features');

export default systemFeatureApi;
